// extracted by mini-css-extract-plugin
export default {"wrapper":"GetMember_wrapper__9Af5s"};